import { AppTemplateRoot } from '@revenuewell/logic-app-template';
import { useOidc } from '@revenuewell/logic-oidc';
import { useEffect, useState } from 'react';
import { useChildrenListener } from '../../../hooks/use-children-listener';
import { useEventBus } from '../../../hooks/use-event-bus';
import Main from '../main/main';
import style from './app.module.scss';

export default function App() {
  const { onLogout } = useChildrenListener();
  const { listen, unlisten } = useEventBus();
  const { logoutRedirect } = useOidc();
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => setReady(true), 500);
  }, []);

  useEffect(() => {
    const listener = listen('logout', () => logoutRedirect());
    return () => unlisten('logout', listener);
  }, []);

  useEffect(() => {
    if (onLogout) onLogout(logoutRedirect);
  }, [onLogout, logoutRedirect]);

  return (
    <AppTemplateRoot className={style.app} ready={ready} productMenu={{ render: false }}>
      <Main />
    </AppTemplateRoot>
  );
}